import type { PerformanceHistory } from "./external-data/performanceHistory";

type Period = '3-months' | '6-months' | '12-months'

function calculate(history: PerformanceHistory[keyof PerformanceHistory], length: number) {

  return history
    .slice(-length)
    .map(entry => (entry.pnl + 100) / 100)
    .reduce((acc, cur) => acc * cur)
    * 100
  
}

interface CalculateCompoundRoiReturn {
  pnl: number
  period: {
    name: Period,
    lengthInMonths: number
  }
}

// returns an object from which the .pnl that can be passed into formatRoi
export default function calculateCompoundRoi(history: PerformanceHistory[keyof PerformanceHistory], period: Period | 'auto' = 'auto'): CalculateCompoundRoiReturn {

  const periodToLengthMap: Record<Period, number> = {
    '3-months': 3,
    '6-months': 6,
    '12-months': 12
  }

  // does provided histroy have enough data for selected period?
  if(period !== 'auto' && ( history.length < periodToLengthMap[period] )) throw new Error(`The history data provided has less than ${periodToLengthMap[period]} data points, but you're trying to generate compound ROI for ${period}`)

  // calculate for selected period
  if(period !== 'auto') return {
    period: {
      name: period,
      lengthInMonths: periodToLengthMap[period]
    },
    pnl: calculate(history, periodToLengthMap[period])
  }
  // calculate for all periods, then choose the best result
  else {

    let best: CalculateCompoundRoiReturn | undefined;
  
    (Object.entries(periodToLengthMap) as ([Period, number])[]).forEach(([k, v]) => {

      const pnl = calculate(history, v)

      if(
        !best 
        || (best && (pnl > best.pnl))
      ) {
        best = {
          pnl,
          period: {
            name: k,
            lengthInMonths: v
          }
        }
      }

    })

    return best as CalculateCompoundRoiReturn

  }

  
}